/**
 * @function to create Session to all apis
 * @param var countryCode and languageCode 
 * @returns  api url & payload the digital create session
 */
 
let triggerCreateSession = (countryCode, languageCode,host) => {
    const createSessionurl = `https://${host}/wudgtsrvs/mobiliser/rest/channel/GwpCreateSession`
        try {
            const reqPayload =
            {
                channel: {
                    device_identifier: 'RESPONSIVE_WEB',
                    is_responsive: 'true',
                    name: 'Western Union',
                    type: 'WEB',
                    version: '9Z00'
                },
                device: {
                    id: '',
                    type: 'WEB'
                },
                external_reference_no: '1',
                locale: {
                    'country_code': countryCode,
                    'language_code': languageCode
                },
                security: {
                    client_ip: '245024209201'
                }
            }

            return {
                createSessionurl,
                reqPayload
              }
            
        } catch (e) {
            console.warn('Error in create session service', e)
        }

}

const getCurrentDatetime = () => {
    let currentDate = new Date();
    let time = currentDate.getHours() + ":" + currentDate.getMinutes() + ":" + currentDate.getSeconds();
    const TZoffset = currentDate.getTimezoneOffset();    
    return (new Date(currentDate.getTime() - (TZoffset * 60 * 1000))).toISOString().split('T')[0] +" "+ time;   
}

let createSessionInFlight = null;
let lastSessionParams = {};

const createSessionMethod = async (country_iso_code, lang_code, host) => {
    const paramsKey = `${country_iso_code}|${lang_code}|${host}`;
    if (createSessionInFlight && lastSessionParams.key === paramsKey) {
        return createSessionInFlight;
    }
    const {createSessionurl, reqPayload} = await triggerCreateSession(country_iso_code, lang_code, host);
    lastSessionParams = { key: paramsKey };
    createSessionInFlight = httpRequest.post(createSessionurl, reqPayload, { "Content-type": "application/json" })
        .finally(() => {
            createSessionInFlight = null;
            lastSessionParams = {};
        });
    return createSessionInFlight;
}
